export const types = [
  { value: "Internship", label: "Internship" },
  { value: "Apprenticeship", label: "Apprenticeship" },
  { value: "Job Shadowing", label: "Job Shadowing" },
  { value: "Cooperative Education", label: "Cooperative Education" },
  { value: "School-Based Enterprise", label: "School-Based Enterprise" },
  { value: "Service Learning", label: "Service Learning" },
  { value: "Simulated Work Environment", label: "Simulated Work Environment" },
  { value: "Industry-Led Project", label: "Industry-Led Project" },
  { value: "Mentorship Program", label: "Mentorship Program" },
  { value: "Field Trip / Industry Tour", label: "Field Trip / Industry Tour" },
  {
    value: "Guest Speaker / Career Panel",
    label: "Guest Speaker / Career Panel",
  },
  { value: "Clinical Experience", label: "Clinical Experience" },
  { value: "Entrepreneurship Program", label: "Entrepreneurship Program" },
  { value: "Work-Study", label: "Work-Study" },
  {
    value: "Micro-credential / Certification",
    label: "Micro-credential / Certification",
  },
  { value: "Research Assistantship", label: "Research Assistantship" },
  {
    value: "Professional Skills Workshop",
    label: "Professional Skills Workshop",
  },
  { value: "Industry-Specific Training", label: "Industry-Specific Training" },
  {
    value: "Virtual / Remote Work Experience",
    label: "Virtual / Remote Work Experience",
  },
  {
    value: "Seasonal / Event-Based Work",
    label: "Seasonal / Event-Based Work",
  },
  { value: "Other", label: "Other" },
].sort((a, b) => a.label.localeCompare(b.label));
